import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { CopyToClipboard } from "react-copy-to-clipboard";

import Button from "../../components/Common/Button";
import TransactionNotFoundComponent from "./TransactionNotFoundComponent";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import { formatRupiah } from "../../components/Common/utils";
import html2canvas from "html2canvas";
import { useQRCode } from 'next-qrcode';

import { ReactComponent as LinkIcon } from "../../assets/icon/link.svg";
import { ReactComponent as ClipboardIcon } from "../../assets/icon/clipboard.svg";
import { ReactComponent as PrintIcon } from "../../assets/icon/print.svg";
import { ReactComponent as LeftArrowIcon } from "../../assets/icon/leftArrow.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/icon/material-symbols_keyboard-arrow-down.svg";

import ConditionalRender from "../../components/Common/ConditionalRender";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CountdownTimer from "../../components/Common/CountdownTimer";
import pusherJs from "pusher-js";
import Barcode from "react-barcode";
import useDarkMode from "../../components/Common/darkmode/DarkModeObserver";
import StatusInfo from "./StatusInfo";
import ShorcutPage from "../Hompages/ShorcutPage";

function InvoicePage() {
  const apiKeyPusher = process.env.REACT_APP_PUSHER_KEY;
  const clusterPusher = process.env.REACT_APP_PUSHER_CLUSTER;
  const clusterName = process.env.REACT_APP_PUSHER_NAME;

  const isWebSetting = localStorage.getItem('isWebSetting');
  const parseWebSetting = JSON.parse(isWebSetting);
  const [detailInvoice, setDetailInvoice] = useState([]);

  const [invoiceLoading, setInvoiceLoading] = useState(true);
  const [statusPages, setStatusPages] = useState(true);
  const [expired, isExpired] = useState(false);

  const location = useLocation();
  const isDarkMode = useDarkMode();
  const { Image } = useQRCode();

  const formattedPath = location.pathname.replace("/invoice/", "");

  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    fetchDataProduct();
  }, [formattedPath]);

  useEffect(() => {
    // pusherJs.logToConsole = true;
    const pusher = new pusherJs(apiKeyPusher, {
      cluster: clusterPusher,
    });
    const channel = pusher.subscribe(clusterName);
    const handleNewMessage = (data) => {
      if (data.statusCode === 200) {
        if (data.Code === "actionInvoice") {
          const mergedData = {
            ...detailInvoice,
            ...data.data,
          };
          if (data?.data?.invoice === detailInvoice?.invoice) {
            setDetailInvoice(mergedData);
          }
        }
      }
    };
    channel.bind("invoice", handleNewMessage);
    return () => {
      channel.unbind("invoice", handleNewMessage);
      pusher.disconnect();
    };
  }, [apiKeyPusher, detailInvoice]);

  const fetchDataProduct = async () => {
    setInvoiceLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("invoice", formattedPath);

      const response = await ApiService({
        baseurl: "user/invoice",
        XGORDON: "INVOICE",
        method: "POST",
        body: params,
      });
      setInvoiceLoading(false);
      if (response?.statusCode === 200) {
        setStatusPages(true);
        setDetailInvoice(response.result.data);
      } else {
        setStatusPages(false);
        setDetailInvoice([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const downloadQRCode = () => {
    html2canvas(document.querySelector("#react-qrcode-logo1")).then(function (
      canvas
    ) {
      const link = document.createElement("a");
      link.download = `${detailInvoice.nama_kategori} ${detailInvoice.nama_layanan}.png`;
      link.href = canvas.toDataURL();
      link.click();
    });
  };
  const printDocument = () => {
    window.print();
  };
  return statusPages === true ? (
    <div className="flex flex-col gap-3 flex-1" id="printDocument">
      <ShorcutPage />
      <div className="flex flex-col gap-3 flex-1 p-3 overflow-hidden relative ove lg:rounded-md rounded-none shadow-inner  bg-cardLight dark:bg-cardDark">
        <div className="flex flex-col border-b-2 pb-3 border-[#2121212b] dark:border-[#ffffff2b] sm:flex-row gap-2 sm:items-center justify-between ">
          <div className="flex sm:flex-row flex-col gap-1 sm:items-center">
            <div className="flex flex-row gap-1 items-center">
              <span className="text-xl   font-semibold  line-clamp-1">
                {detailInvoice?.invoice || "Please Wait ...."}{" "}
              </span>
              <CopyToClipboard
                text={detailInvoice?.invoice}
                onCopy={() => {
                  toast.success(detailInvoice?.invoice + " Tersalin", {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }}
              >
                <ClipboardIcon
                  className="h-4 w-5  cursor-pointer"
                  fill={isDarkMode ? "#ffffff" : "#000000"}
                />
              </CopyToClipboard>
            </div>
            <span className="font-normal opacity-60">
              Tanggal Transaksi : {detailInvoice?.tanggal || ""}
            </span>
          </div>

          <div className="flex flex-row items-center">
            <Button
              initialValue="Cetak Invoice"
              iconLeft={<PrintIcon />}
              type="fill"
              color={"#ffffff"}
              className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor text-xs flex-1 h-9"
              onClick={() => printDocument()}
            />
          </div>
        </div>
        <StatusInfo detailInvoice={detailInvoice} />
      </div>
      <div className="flex flex-col gap-3 flex-1 p-3 overflow-hidden relative ove lg:rounded-md rounded-none shadow-inner  bg-cardLight dark:bg-cardDark">
        <div className="flex sm:flex-row flex-col justify-between gap-2 ">
          <div className="flex flex-row gap-2">
            {detailInvoice.backround_layanan && (
              <LazyLoadImage
                src={detailInvoice.backround_layanan}
                alt={detailInvoice.nama_layanan}
                className=" object-cover   w-14 aspect-square rounded-md"
                effect="blur"
              />
            )}
            <div className="flex flex-col flex-1 justify-center">
              <span className="flex flex-col flex-1 sm:text-lg text-sm font-semibold line-clamp-2">
                {detailInvoice.nama_layanan}
              </span>
              <span className="flex flex-col opacity-60 text-sm  line-clamp-2">
                {detailInvoice.nama_kategori}
              </span>
            </div>
          </div>
          <div className="flex flex-row gap-2 items-center justify-center">
            <span className="flex flex-col text-sm text-center line-clamp-1">
              Status :
            </span>
            {!expired && detailInvoice.status === "not_paid" ? (
              <div className="flex flex-row items-center gap-2">
                <div className="flex flex-col  items-center bg-[#22BDE2] p-3 py-2 gap-2 rounded-lg">
                  <span className="flex flex-col w-full items-center text-center font-bold  line-clamp-1">
                    <CountdownTimer
                      type={1}
                      expired={detailInvoice.expired}
                      onResponse={(a) => {
                        if ("00:00:00" > a) {
                          isExpired(true);
                        } else {
                          isExpired(false);
                        }
                      }}
                    />
                  </span>
                </div>
              </div>
            ) :
              <div className={`${detailInvoice.status === "cancel"
                ? "bg-[#F42536]"
                : detailInvoice.status === "refund"
                  ? "bg-[#ED610A]"
                  : detailInvoice.status === "pending"
                    ? "bg-[#ED610A]"
                    : detailInvoice.status === "paid"
                      ? "bg-[#ED610A]"
                      : detailInvoice.status === "processing"
                        ? "bg-[#3694ff]"
                        : detailInvoice.status === "success"
                          ? "bg-[#0ABE5D]"
                          : null
                } rounded-lg `}>
                <span className=" text-sm font-medium line-clamp-1 p-3 py-2 text-darkColor">
                  {detailInvoice.status}
                </span>
              </div>
            }
          </div>
        </div>
        <ConditionalRender
          productsData={detailInvoice}
          isLoading={invoiceLoading}
          model={"emptyData"}
        >
          <div className="flex flex-col-reverse lg:flex-row gap-2">
            <div className="flex flex-col basis-5/12 ">
              <div className="flex flex-col rounded-lg p-3 gap-3 bg-lightColor dark:bg-darkColor">
                <span className="flex flex-col text-base font-semibold text-center">
                  Detail Pesanan
                </span>
                <div className="flex flex-col flex-1 gap-2 ">
                  {Object.keys(detailInvoice).map((key) => {
                    if (["nama_kategori", "nama_layanan", "data"].includes(key)) {
                      return (
                        <div
                          key={key}
                          className="flex flex-row justify-between bg-cardLight dark:bg-cardDark p-2 rounded-sm"
                        >
                          <span className="flex flex-col text-sm flex-1">
                            {key
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (c) => c.toUpperCase())}
                          </span>
                          <span className="flex flex-col text-sm font-semibold text-right">
                            {key === "total_bayar" ? (
                              <CopyToClipboard
                                text={formatRupiah(detailInvoice[key])}
                                onCopy={() =>
                                  toast.success(
                                    formatRupiah(detailInvoice[key]) +
                                    " Tersalin",
                                    {
                                      position: toast.POSITION.TOP_RIGHT,
                                    }
                                  )
                                }
                              >
                                <div className="cursor-pointer flex flex-row gap-1 ">
                                  {typeof value === "number"
                                    ? detailInvoice[key]
                                      .replace(/_/g, " ")
                                      .replace(/\b\w/g, (c) => c.toUpperCase())
                                    : formatRupiah(detailInvoice[key])}
                                  <ClipboardIcon
                                    className="h-4 w-4  cursor-pointer"
                                    fill={isDarkMode ? "#ffffff" : "#000000"}
                                  />
                                </div>
                              </CopyToClipboard>
                            ) : typeof value === "number" ? (
                              detailInvoice[key]
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase())
                            ) : (
                              detailInvoice[key]
                            )}
                          </span>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
                {!expired && detailInvoice.status_pembayaran !== "success" && detailInvoice.status_pembayaran !== "cancel" && detailInvoice.tipe_pembayaran === "button" && (
                  <div className="flex  flex-col ">
                    <span className="text-sm   text-center p-3">
                      Dalam pembayaran menggunakan {detailInvoice.nama_pembayaran}, mohon klik tombol dibawah, maka anda akan diarahkan ke web official dana untuk melakukan pembayaran
                    </span>
                  </div>
                )}
                {!expired && detailInvoice.status_pembayaran !== "success" && detailInvoice.status_pembayaran !== "cancel" && detailInvoice.tipe_pembayaran === "notifikasi" && (
                  <div className="flex  flex-col ">
                    <span className="text-sm   text-center p-3">
                      Dalam pembayaran menggunakan {detailInvoice.nama_pembayaran}, mohon klik tombol dibawah, maka anda akan diarahkan ke web official dana untuk melakukan pembayaran
                    </span>
                  </div>)}
              </div>
            </div>
            <div className="flex flex-col flex-1 rounded-lg p-3 gap-3 bg-lightColor dark:bg-darkColor">
              <span className="flex flex-col text-base font-semibold text-center">
                Pembayaran
              </span>
              <div className="flex sm:flex-row flex-col gap-2">
                <div className="flex flex-col basis-4/12 bg-cardLight dark:bg-cardDark gap-2 ">
                  {!expired && detailInvoice.status_pembayaran !== "success" && detailInvoice.status_pembayaran !== "cancel" && (
                    <div className="flex flex-1 flex-col w-full">
                      {detailInvoice.tipe_pembayaran === "QRIS" && (
                        <div className="flex flex-col w-full items-center justify-center aspect-square max-h-72" id={"react-qrcode-logo1"}>
                          <div className="">
                            <Image
                              text={detailInvoice.aksi}
                              options={{
                                type: 'image/jpeg',
                                quality: 0.3,
                                errorCorrectionLevel: 'M',
                                margin: 3,
                                // width: 400,
                                scale: 4,
                                color: {
                                  dark: '#212121',
                                  light: '#ffffff',
                                },
                              }}
                            />
                          </div>
                        </div>)}
                      {detailInvoice.tipe_pembayaran === "BARCODE" && (
                        <div className="flex flex-col w-full items-center justify-center ">
                          <Barcode value={detailInvoice?.aksi}
                            width={2}
                            height={50}
                            format={"CODE128"}
                            displayValue={true}
                            fontOptions={""}
                            font={"monospace"}
                            textAlign={"center"}
                            textPosition={"bottom"}
                            textMargin={2}
                            fontSize={20}
                            lineColor={"#000000"}
                            margin={10} />
                        </div>)}

                      {detailInvoice.tipe_pembayaran === "text" && (
                        <div className="flex flex-col w-full items-center gap-2 justify-center h-full ">
                          <LazyLoadImage
                            src={detailInvoice.gambar_pembayaran}
                            alt={detailInvoice.nama_pembayaran}
                            className=" object-contain  h-16 aspect-[2/1] rounded-lg"
                            effect="blur"
                          />
                          <CopyToClipboard
                            text={detailInvoice?.norek}
                            onCopy={() =>
                              toast.success(detailInvoice.norek + " Tersalin", {
                                position: toast.POSITION.TOP_RIGHT,
                              })
                            }
                          >
                            <div className="cursor-pointer flex flex-row gap-2 justify-between w-full p-3 items-center border-[#9ca3af50] border-[1px] rounded-md ">
                              <span className="text-sm  text-left">
                                {detailInvoice?.norek}
                              </span>
                              <div className="p-2 rounded-lg bg-[#f3f3f3]">
                                <ClipboardIcon className="h-4 w-4  cursor-pointer" />
                              </div>
                            </div>
                          </CopyToClipboard>
                          <span className="text-xs  text-left">
                            {detailInvoice?.aksi}
                          </span>
                        </div>)}
                      {detailInvoice.tipe_pembayaran === "VA" && (
                        <div className="flex flex-col w-full items-center gap-2 justify-center h-full ">
                          <LazyLoadImage
                            src={detailInvoice.gambar_pembayaran}
                            alt={detailInvoice.nama_pembayaran}
                            className=" object-contain  h-16 aspect-[2/1] rounded-lg"
                            effect="blur"
                          />
                          <CopyToClipboard
                            text={detailInvoice.aksi}
                            onCopy={() =>
                              toast.success(detailInvoice.aksi + " Tersalin", {
                                position: toast.POSITION.TOP_RIGHT,
                              })
                            }
                          >
                            <div className="cursor-pointer flex flex-row gap-2 justify-between w-full p-3 items-center border-[#9ca3af50] border-[1px] rounded-md ">
                              <div className="flex flex-col gap-1  flex-1  w-full">
                                <span className="text-sm  text-left">
                                  Nomor Virtual Account
                                </span>
                                <span className="text-lg  font-semibold text-left line-clamp-1">
                                  {detailInvoice.aksi}
                                </span>
                              </div>
                              <div className="p-2 rounded-lg bg-[#f3f3f3]">
                                <ClipboardIcon className="h-4 w-4  cursor-pointer" />
                              </div>
                            </div>
                          </CopyToClipboard>
                        </div>)}

                      {detailInvoice.tipe_pembayaran === "button" && (
                        <div className="flex flex-col w-full items-center gap-2 justify-center h-full ">
                          <LazyLoadImage
                            src={detailInvoice.gambar_pembayaran}
                            alt={detailInvoice.nama_pembayaran}
                            className=" object-contain  h-16 aspect-[2/1] rounded-lg"
                            effect="blur"
                          />
                        </div>)}
                      {detailInvoice.tipe_pembayaran === "notifikasi" && (
                        <div className="flex flex-col w-full items-center gap-2 justify-center h-full ">
                          <LazyLoadImage
                            src={detailInvoice.gambar_pembayaran}
                            alt={detailInvoice.nama_pembayaran}
                            className=" object-contain  h-16 aspect-[2/1] rounded-lg"
                            effect="blur"
                          />
                          <Button
                            initialValue={detailInvoice.aksi}
                            iconRight={<LeftArrowIcon className="h-4 w-4" />}
                            type="fill"
                            color="bg-[#FFBC06] w-full "
                            onClick={() =>
                              toast.success(detailInvoice.aksi, {
                                position: toast.POSITION.TOP_RIGHT,
                              })
                            }
                          />
                        </div>)}
                    </div>
                  )}
                  {detailInvoice.status_pembayaran !== "not_paid" ? (
                    <div className="flex flex-1 flex-col w-full max-h-48">
                      <div className="flex flex-col w-full items-center justify-center h-48 relative">
                        <img
                          alt={"status"}
                          src={
                            detailInvoice.status === "cancel"
                              ? parseWebSetting?.animasiPesanan?.cancel
                              : detailInvoice.status === "refund"
                                ? parseWebSetting?.animasiPesanan?.refund
                                : detailInvoice.status === "success"
                                  ? parseWebSetting?.animasiPesanan?.success
                                  : detailInvoice.status === "pending"
                                    ? parseWebSetting?.animasiPesanan?.pending
                                    : detailInvoice.status === "processing"
                                      ? parseWebSetting?.animasiPesanan?.processing
                                      : null
                          }
                          className="absolute w-full h-full  object-contain" />
                      </div>
                    </div>
                  ) : null}
                  {(detailInvoice.status_pembayaran === "not_paid" && expired) ? (
                    <div className="flex flex-1 flex-col w-full max-h-48">
                      <div className="flex flex-col w-full items-center justify-center h-48 relative">
                        <img
                          alt={"status"}
                          src={parseWebSetting?.animasiPesanan?.not_paid}
                          className="absolute w-full h-full  object-contain" />
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="flex flex-col flex-1 gap-2 justify-between ">
                  <div className="flex flex-col flex-1 gap-2  ">
                    {Object.keys(detailInvoice).map((key) => {
                      if (["harga_layanan", "status", "fee", "total_bayar"].includes(key)) {
                        return (
                          <div
                            key={key}
                            className="flex flex-row justify-between bg-cardLight dark:bg-cardDark p-2 rounded-sm"
                          >
                            <span className="flex flex-col text-sm flex-1">
                              {key
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase())}
                            </span>
                            <span className="flex flex-col text-sm font-semibold text-right">
                              {key === "total_bayar" ? (
                                <CopyToClipboard
                                  text={formatRupiah(detailInvoice[key])}
                                  onCopy={() =>
                                    toast.success(
                                      formatRupiah(detailInvoice[key]) +
                                      " Tersalin",
                                      {
                                        position: toast.POSITION.TOP_RIGHT,
                                      }
                                    )
                                  }
                                >
                                  <div className="cursor-pointer flex flex-row gap-1 ">
                                    {typeof value === "number"
                                      ? detailInvoice[key]
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (c) => c.toUpperCase())
                                      : formatRupiah(detailInvoice[key])}
                                    <ClipboardIcon
                                      className="h-4 w-4  cursor-pointer"
                                      fill={isDarkMode ? "#ffffff" : "#000000"}
                                    />
                                  </div>
                                </CopyToClipboard>
                              ) : typeof value === "number" ? (
                                detailInvoice[key]
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (c) => c.toUpperCase())
                              ) : (
                                detailInvoice[key]
                              )}
                            </span>
                          </div>
                        );
                      }
                      return null;
                    })}
                  </div>
                  {detailInvoice.keterangan === "" ? null : (
                    <div className="flex flex-col rounded-lg  overflow-hidden ">
                      <div className="flex flex-row flex-1 p-3">
                        <div className="flex flex-1 ">
                          <span className="text-sm font-semibold  line-clamp-1">
                            Keterangan
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-row flex-1 p-3">
                        <div className="flex flex-1">
                          <span className="text-sm ">
                            {detailInvoice?.keterangan}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>

              {!expired && detailInvoice.status_pembayaran !== "success" && detailInvoice.status_pembayaran !== "cancel" && detailInvoice.tipe_pembayaran === "QRIS" && (
                <div className="flex  flex-col ">
                  <Button
                    initialValue="Download QR Code"
                    iconRight={<LinkIcon className="w-3 h-3" />}
                    type="fill"
                    color={"#ffffff"}
                    className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] h-12 text-darkColor"
                    onClick={() => downloadQRCode()}
                  />
                </div>)}
              {!expired && detailInvoice.status_pembayaran !== "success" && detailInvoice.status_pembayaran !== "cancel" && detailInvoice.tipe_pembayaran === "button" && (
                <div className="flex  flex-col ">
                  <Button
                    initialValue="Bayar Sekarang"
                    iconRight={<LinkIcon className="w-3 h-3" />}
                    type="fill"
                    color={"#ffffff"}
                    className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] h-12 text-darkColor"
                    onClick={() =>
                      (window.open(detailInvoice.aksi, '_blank'))
                    }
                  />
                </div>
              )}
              {!expired && detailInvoice.status_pembayaran !== "success" && detailInvoice.status_pembayaran !== "cancel" && detailInvoice.tipe_pembayaran === "notifikasi" && (
                <div className="flex  flex-col ">
                  <Button
                    initialValue={detailInvoice?.aksi}
                    iconRight={<LinkIcon className="w-3 h-3" />}
                    type="fill"
                    color={"#ffffff"}
                    className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] h-12 text-darkColor"
                    onClick={() =>
                      toast.success(detailInvoice.aksi, {
                        position: toast.POSITION.TOP_RIGHT,
                      })
                    }
                  />
                </div>)}
              {!expired && detailInvoice.status_pembayaran !== "success" && detailInvoice.status_pembayaran !== "cancel" && detailInvoice.tipe_pembayaran === "VA" && (
                <div className="flex  flex-col ">
                  <CopyToClipboard
                    text={detailInvoice.aksi}
                    onCopy={() =>
                      toast.success(detailInvoice.aksi + " Tersalin", {
                        position: toast.POSITION.TOP_RIGHT,
                      })
                    }
                  >
                    <div className="cursor-pointer flex flex-row gap-2 p-3 items-center rounded-lg justify-center  bg-[#ffbc02]">
                      <span className="text-sm font-medium  text-center ">
                        Salin Nomor Virtual Account
                      </span>
                      <LinkIcon className="w-3 h-3" />
                    </div>
                  </CopyToClipboard>
                </div>)}
            </div>
          </div>
        </ConditionalRender>
      </div>
      {detailInvoice.faq === undefined ? null :
        <ConditionalRender
          productsData={detailInvoice}
          isLoading={invoiceLoading}
          model={"emptyData"}
        >
          {detailInvoice.faq.map((item, index) => {
            return (
              <div key={index} className="flex flex-col print:hidden">
                <button className={`flex p-3 bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  flex-row justify-between items-center rounded-t-lg ${activeIndex !== index && 'rounded-b-lg'}`}
                  onClick={() => toggleAccordion(index)}>
                  <div
                    dangerouslySetInnerHTML={{ __html: item.pertanyaan }}
                    className={` text-base line-clamp-1 text-darkColor`}
                  />
                  <ArrowDownIcon fill="#212121" className={`-rotate-90 ${activeIndex === index && '-rotate-0'}`} />
                </button>

                {activeIndex === index && (
                  <div className="flex p-3 bg-cardLight dark:bg-cardDark flex-row justify-start gap-2 items-center rounded-b-lg shadow-inner"
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: item.jawaban }}
                      className={` text-base text-left pl-0 pb-0`}
                    />
                  </div>)}
              </div>
            )
          })}
        </ConditionalRender>}
    </div>
  ) : (
    <TransactionNotFoundComponent />
  );
}

export default InvoicePage;
